import React from 'react';
import SEO from './SEO';

function DeleteAccount() {
  return (
    <div className="container">
      <SEO 
        title="Account & Data Deletion Request" 
        description="Learn how to request the deletion of your Nouria account and all associated personal and health data."
        canonical="/delete-account"
      />
      <section className="content-section">
        <h2>Delete Account</h2>
        <p className="last-updated">Last updated: {new Date().toISOString().split('T')[0]}</p>

        <h3>Nouria — Account & Data Deletion Request</h3>
        <p><strong>Developer:</strong> Masala Chai Labs</p>
        <p><strong>Contact Email:</strong> <a href="mailto:support@nouria.fit">support@nouria.fit</a></p>

        <p>
          We value your privacy and provide simple options to delete your account and all associated personal/health data.
        </p>

        <h3>How to Delete Your Account and Data:</h3>
        <p>You can request deletion using either of the following methods:</p>
        <ul>
          <li>
            <strong>In-App (Recommended):</strong> Open the Nouria app, navigate to Preferences, scroll to Privacy & Data, and tap Request account deletion. This will prepare a pre-filled deletion request email.
          </li>
          <li>
            <strong>By Email:</strong> Send an email from your registered account to <a href="mailto:support@nouria.fit">support@nouria.fit</a> with the subject line "Account Deletion Request".
          </li>
        </ul>

        <h3>What Data is Deleted:</h3>
        <p>Upon receiving your request, we will permanently delete the following within 30 days:</p>
        <ul>
          <li>Your user profile info (name, email, age, gender).</li>
          <li>All physiological data and calculated health metrics (BMI, body fat, etc.).</li>
          <li>All logged history (food logs, weight logs, intermittent fasting logs, and blood reports).</li>
          <li>Any active connections, friends, and Tribe history.</li>
        </ul>
      </section>
    </div>
  );
}

export default DeleteAccount;
